import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_2 = { class: "s20 items-center gap-6 px-0 pb-6 collapse-content active" }
const _hoisted_3 = { class: "s20 flex gap-3 mb-7" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex items-center px-5 gap-6" }
const _hoisted_6 = { class: "s7" }
const _hoisted_7 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_8 = { class: "s7" }
const _hoisted_9 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_10 = { class: "s6" }
const _hoisted_11 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_12 = { class: "table separator skin3 sm selection rounded" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  colspan: "5",
  class: "text-center py-5"
}
const _hoisted_15 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex align-items-center" }
const _hoisted_18 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { style: {"width":"20%"} }
const _hoisted_21 = { class: "text-xl font-semibold mb-2" }
const _hoisted_22 = {
  style: {"width":"15%"},
  class: "text-xl font-semibold mb-2"
}
const _hoisted_23 = {
  key: 0,
  class: "widget s20 border border-3 active shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5"
}
const _hoisted_24 = { class: "s10" }
const _hoisted_25 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_26 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_27 = { class: "s10 text-right" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "tag-state notif stroke" }
const _hoisted_30 = { class: "secondary-font font-semibold text-grey-600 pt-1 mb-4" }
const _hoisted_31 = {
  key: 1,
  class: "widget s20 border border-3 shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5"
}
const _hoisted_32 = { class: "s10" }
const _hoisted_33 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_34 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_35 = { class: "s10 text-right" }
const _hoisted_36 = { class: "mb-4" }
const _hoisted_37 = {
  key: 0,
  class: "tag-state danger stroke"
}
const _hoisted_38 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_39 = { class: "secondary-font font-semibold text-grey-600 py-1" }
const _hoisted_40 = {
  key: 1,
  class: "widget s20 border border-3 shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5"
}
const _hoisted_41 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { reactive, ref, watch, inject } from 'vue';
    import axios from 'axios';
    import { formatAmount } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinancePrelevementsDecaissementsComponent',
  props: {
    startupInfos: {}
  },
  setup(__props: any, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    __expose({ doGetDecaissementDetailsInfos });

    const BACKEND_URL = inject('BACKEND_URL');
    const props = __props;
    const loadingUsers = ref(false);
    const errorMessageUsers = ref('');
    const formData = reactive({
        periode: null as any | null,
    });
    const periodes_options = ref([] as any[]);
    const collectivite = ref(null as any);
    const itemsList = ref([] as any[]);
    const itemsPaginated = ref([] as any[]);
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'DESC',
        sortColumn: 'created_at',
        sortOption: 'created_at_desc',
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const statsInfos = ref({
        montant_decaissement: 0,
        montant_prelevement: 0,
        solde: 0,
        montant_prelevement_expected: 0,
    });

    watch(() => props.startupInfos, (newVal: any) => {
        const isFirstChanged = !collectivite.value;
        collectivite.value = newVal.collectivite;
        periodes_options.value = newVal.periodes;
        formData.periode = newVal.periodes.find((p: any) => p.selected == true);
        if (!formData.periode) {
            formData.periode = newVal.periodes.length > 0 ? { value: newVal.periodes[0].value, label: newVal.periodes[0].label } : null;
        }
        if (isFirstChanged) {
            doGetDecaissementDetailsInfos();
        }
    }, { immediate: true });

    async function doGetDecaissementDetailsInfos() {
        try {
            loadingUsers.value = true;
            errorMessageUsers.value = '';
            const queryParamsRaw = {
                periode: formData.periode?.value || '',
            };
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/finance/prelevements/get_decaissement_infos/${collectivite.value.id}?${queryString}`);

            statsInfos.value.montant_decaissement = httpResponse.data.montant_decaissement;
            statsInfos.value.montant_prelevement = httpResponse.data.montant_prelevement;
            statsInfos.value.solde = httpResponse.data.solde;

            itemsList.value = httpResponse.data.users;
            pagination.total = itemsList.value.length;
            pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
            onPaginate(queryParams.pageNumber);
        } catch (error: any) {
            errorMessageUsers.value = error.message;
        } finally {
            loadingUsers.value = false;
        }
    }
    
    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        const startIndex = (queryParams.pageNumber - 1) * pagination.per_page;
        const endIndex = startIndex + pagination.per_page;
        itemsPaginated.value = itemsList.value.slice(startIndex, endIndex);
    }

    function onSelectPeriode(periode: any) {
        formData.periode = periode;
        doGetDecaissementDetailsInfos();
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[28] || (_cache[28] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Prélèvements / Décaissements </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 black\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter en PDF</span></button><button class=\"btn lg py-3 black\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter en Excel</span></button></div><div class=\"clear-both h-10\"></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodes_options.value, (periode, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["btn", {'light': periode.value == formData.periode?.value, 'light2': periode.value != formData.periode?.value }]),
            onClick: ($event: any) => (onSelectPeriode(periode)),
            key: 'periode_' + index
          }, _toDisplayString(periode.label), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-pop-yellow" }),
            _createTextVNode(" Montant prélevé ")
          ], -1)),
          _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(formatAmount)(statsInfos.value.montant_prelevement)) + " F", 1),
          _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "0%", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", {
            class: "h-40 rounded-100 position-relative overflow-hidden",
            style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
          }, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-pop-yellow",
              style: {"width":"0%"}
            }, " 0% ")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
            _createTextVNode(" Montant décaissé ")
          ], -1)),
          _createElementVNode("h1", _hoisted_9, _toDisplayString(_unref(formatAmount)(statsInfos.value.montant_decaissement)) + " F", 1),
          _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "0%", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "h-40 rounded-100 position-relative overflow-hidden",
            style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
          }, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
              style: {"width":"0%"}
            }, " 0% ")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-green-light" }),
            _createTextVNode(" Montant à prélevé ")
          ], -1)),
          _createElementVNode("h1", _hoisted_11, _toDisplayString(_unref(formatAmount)(statsInfos.value.montant_prelevement_expected)) + " F", 1),
          _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "0%", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("div", {
            class: "h-40 rounded-100 position-relative overflow-hidden",
            style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
          }, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
              style: {"width":"0%"}
            }, " 0% ")
          ], -1))
        ])
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
      _createElementVNode("table", _hoisted_12, [
        _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th"),
            _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/icons/icon-filter-up.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Information")
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/icons/icon-filter-up.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Collectivité")
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/icons/icon-filter-up.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Prélèvement")
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/icons/icon-filter-up.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Décaissement")
            ])
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (loadingUsers.value)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                _createElementVNode("td", _hoisted_14, [
                  (loadingUsers.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("div", { class: "loader dark" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (itemsList.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("td", {
                    colspan: "5",
                    class: "text-center py-5"
                  }, " Aucun membre trouvé. ", -1)
                ]))]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(itemsPaginated.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "text-grey-700 over-effect",
                    key: item.id
                  }, [
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("img", {
                          src: !!item.photo_url ? item.photo_url : '/assets/users_avatar/600w/user.jpg',
                          width: "100%"
                        }, null, 8, _hoisted_19)
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("div", {
                        class: "square-xl rounded-15 ml-3 px-3 py-3",
                        style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
                      }, [
                        _createElementVNode("img", {
                          src: "/assets/logos/logo2.svg",
                          width: "100%"
                        })
                      ], -1))
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, [
                        _cache[13] || (_cache[13] = _createTextVNode(" C788PMKJ   ", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("br", { class: "mb-3" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(item.nom + ' ' + item.prenom), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(item.collectivite_nom), 1),
                    _createElementVNode("td", null, [
                      (item.prelevement_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("h6", _hoisted_25, _toDisplayString(item.prelevement_periode_prelevement_formatted), 1),
                              _createElementVNode("h3", _hoisted_26, _toDisplayString(_unref(formatAmount)(item.prelevement_montant_prelevement)) + " F", 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-600 pb-2 display-none" }, "1m 29j 24min", -1)),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(item.status_prelevement_label), 1)
                              ]),
                              _createElementVNode("h6", _hoisted_30, "Le " + _toDisplayString(item.prelevement_created_at_formatted), 1),
                              _cache[18] || (_cache[18] = _createStaticVNode("<button class=\"btn-ultra w-100 shadow-0 display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 1))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!item.prelevement_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("div", { class: "s20 text-center" }, " Aucun prélèvement ", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      (item.souscription_id)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["widget s20 border border-3 shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5", {'active': item.souscription_statut == 'done' }])
                          }, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("h6", _hoisted_33, _toDisplayString(item.souscription_date_prevision_formatted), 1),
                              _createElementVNode("h3", _hoisted_34, _toDisplayString(_unref(formatAmount)(item.souscription_pouvoir_achat)) + " F", 1),
                              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "secondary-font font-semibold text-purple display-none" }, "1.5%", -1))
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "secondary-font font-semibold text-primary-color pb-1 display-none" }, "1m 29j 24min", -1)),
                              _createElementVNode("div", _hoisted_36, [
                                (item.souscription_statut == 'pending')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "En attente"))
                                  : _createCommentVNode("", true),
                                (item.souscription_statut == 'done')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Effectué"))
                                  : _createCommentVNode("", true)
                              ]),
                              _cache[22] || (_cache[22] = _createElementVNode("p", { class: "secondary-font font-semibold text-grey-600 pt-1 display-none" }, "Date de déblocage", -1)),
                              _createElementVNode("h6", _hoisted_39, _toDisplayString(item.souscription_created_at_formatted), 1)
                            ]),
                            _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"s20 mt-2 display-none\"><p class=\"s10 font-medium text-sm text-grey-600 mt-2\"> Prélèvement <span class=\"text-sm color-success\">(Effectué)</span></p><div class=\"s10\"><button class=\"btn-ultra w-100\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Décaisser</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div>", 1))
                          ], 2))
                        : _createCommentVNode("", true),
                      (!item.souscription_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("div", { class: "s20 text-center" }, " Aucun décaissement ", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createVNode(_component_custom_pagination, {
          modelValue: queryParams.pageNumber,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((queryParams.pageNumber) = $event)),
            onPaginate
          ],
          total: pagination.total,
          "per-page": pagination.per_page,
          last_page: pagination.last_page
        }, null, 8, ["modelValue", "total", "per-page", "last_page"])
      ])
    ])
  ]))
}
}

})